import React, { Component } from "react";
import { Link } from "react-router-dom";

class EmailSection extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className="section-top form-section">
              <h1 className="text-bold heading">PRIVACY RIGHTS PORTAL</h1>
              <p>
                This 7-Eleven and Speedway Privacy Rights Portal allows
                individuals to exercise certain privacy rights which may vary by
                state. You may complete this form below to submit requests via
                this Portal. By doing so, you consent to receive a response to
                the email address or cell phone number entered into the form.
              </p>
              <p>
                <br />
              </p>
              <p>
                We may need to verify your identity before we’re able to fulfill
                your request. If you maintain an account with us, we may verify
                your identity through existing authentication practices for the
                account (e.g., login and password). If you are not a registered
                member, we may verify your identity by matching two or three
                data points that you provide with data points that we maintain
                and have determined to be reliable for the purposes of
                verification (e.g., browser or device ID or purchasing history).
              </p>
              <p>
                <br />
              </p>
              <p>
                The personal information you submit below will be used to
                process your request and to keep a record of both your request
                and our response.
              </p>
              <p>
                <br />
              </p>
              <p className="text-bold">
                If you connect with our apps using Facebook: use this
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &nbsp;link
                </a>
              </p>
              <p className="text-bold">
                If you have a phone-only/SMS account: use this
                <Link to="/phone" target="_blank">
                  &nbsp;link.
                </Link>
              </p>
              <p>
                <br></br>
              </p>
              <p>
                <span className="text-bold">*Deletion Requests: </span>
                <span>
                  Deleting personal information associated with a rewards
                  account will result in the deletion of the account(s) linked
                  to the information being deleted. This includes, but is not
                  limited to transaction history, rewards earned and other
                  linked information.
                </span>
              </p>
              <p>
                <br></br>
              </p>
              <p>
                For more information about privacy rights provided in certain
                jurisdictions, please use the following links for{" "}
                <a
                  href="https://www.7-eleven.com/consumer-privacy-notice#additional-notice-california"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  7-Eleven
                </a>{" "}
                and or{" "}
                <a
                  href="https://www.speedway.com/about/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Speedway
                </a>{" "}
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmailSection;



// WEBPACK FOOTER //
// src/components/EmailSection.js